import React, { Component } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 400;
  display: ${(props) => props.isOpen ? 'inherit' : 'none'};
`;

const Backdrop = styled.div`
  width: 100%;
  height: 100%;
  background: #333;
  opacity: .8;
  position: absolute;
  left: 0;
  top: 0;
`;

const ImageContaienr = styled.div`
  width: 100%;
  height: 100%;
  z-index: 501;
  position: absolute;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`;

const Toolbar = styled.div`
  position: absolute;
  top: 10px;
  right: 20px;
  left: 20px;
`;

const MainImage = styled.img`
  transform: rotate(${(props) => props.rotation}deg);
  max-height: 90%;

  ${(props) => {
    if (props.rotation === 0 || props.rotation === 180) {
      return 'max-width: 600px;';
    }
    return 'height: 60%;';
  }}
`;

const NavigationButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  opacity: ${(props) => props.enabled ? '1' : '0'};
  pointer-events: ${(props) => props.enabled ? 'auto' : 'none'};
  padding: 0;
  ${(props) => props.right && 'float: right;'}

  > img {
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
  }
`;

export class ImageViewer extends Component {
  constructor(props) {
    super(props);
    this.handleImageRotation = this.handleImageRotation.bind(this);
  }

  handleImageRotation() {
    const { images, currentImage } = this.props;
    const newRotation = images[currentImage].rotation + 90;

    if (newRotation === 360) {
      images[currentImage].handleRotation(images[currentImage].id, 0);
    } else {
      images[currentImage].handleRotation(images[currentImage].id, newRotation);
    }
  }

  render() {
    const {
      isOpen, onClose, images, currentImage, onClickNext, onClickPrev, removeImage,
    } = this.props;

    if (!images || !images.length) {
      return null;
    }

    return (
      <Wrapper isOpen={isOpen}>
        <Backdrop />
        <ImageContaienr>
          <NavigationButton
            enabled={currentImage > 0}
            onClick={onClickPrev}
            size='100'
          >
            <img
              alt="icon"
              src="/ic-left.svg"
            />
          </NavigationButton>
          <Toolbar>
            <NavigationButton
              enabled
              onClick={onClose}
              right
              size='40'
            >
              <img
                alt="presentation"
                src="/ic-cancle-white.svg"
              />
            </NavigationButton>
            <NavigationButton
              enabled
              onClick={this.handleImageRotation}
              size='25'
            >
              <img
                alt="icon"
                src="/ic-rotate-white.svg"
              />
            </NavigationButton>
            <NavigationButton
              enabled
              size='25'
            >
              <a
                download
                href={images[currentImage] ? images[currentImage].downloadLink : ''}
                target='blank'
              >
                <img
                  alt="icon"
                  src="/ic-download-white.svg"
                />
              </a>
            </NavigationButton>
            <NavigationButton
              enabled
              onClick={() => removeImage(images[currentImage].id)} //eslint-disable-line
              size='25'
            >
              <img
                alt="icon"
                src="/ic-delete-white.svg"
              />
            </NavigationButton>
          </Toolbar>
          <MainImage
            alt="presentation"
            rotation={images[currentImage].rotation || 0}
            src={images[currentImage] ? images[currentImage].downloadLink : ''}
          />
          <NavigationButton
            enabled={currentImage < images.length - 1}
            onClick={onClickNext}
            size='100'
          >
            <img
              alt="icon"
              src="/ic-right.svg"
            />
          </NavigationButton>
        </ImageContaienr>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageViewer.js